/**
 * Per-layout stylesheets (Brad, 2026-10-01). calculator-app.ftl links a
 * layout's calc-<name>.css above the mount div, so it has loaded before the
 * calculator renders. This is the fallback for a page that doesn't have that
 * link: HTML cached by the CDN from before the sheets were split out.
 *
 * `versionedFrom` is the entry script's import.meta.url, whose ?v= query (the
 * FTL's calcAppVersion) is reused so the fallback is cache-busted the same way.
 */
export function ensureStylesheet(name: string, assetBase: string, versionedFrom: string): void {
  if (document.querySelector(`link[data-hsab-calc-css="${name}"]`)) return;

  let query = '';
  try {
    query = new URL(versionedFrom).search;
  } catch {
    // no version query available; the plain URL still works
  }

  const link = document.createElement('link');
  link.rel = 'stylesheet';
  link.href = `${assetBase}calc-${name}.css${query}`;
  link.dataset.hsabCalcCss = name;
  document.head.appendChild(link);
}
